import { render, staticRenderFns } from "./POSOrderDetails.vue?vue&type=template&id=505f7b81&scoped=true&"
import script from "./POSOrderDetails.vue?vue&type=script&lang=js&"
export * from "./POSOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./POSOrderDetails.vue?vue&type=style&index=0&id=505f7b81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505f7b81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VChip,VIcon,VImg})
